export default function formatAddress({
  line_1: line1,
  line_2: line2,
  postal_code: postalCode,
  city,
  state,
}) {
  const addressLines = [];
  if (line1) addressLines.push(line1.trim());
  if (line2) addressLines.push(line2.trim());
  if (city) addressLines.push(city.trim());
  if (state) addressLines.push(state.trim());
  return `${addressLines.join(', ')} ${postalCode ?? ''}`.trim();
}
